import { FEATURE_FLAG_STATES, FEATURE_FLAG_SYNC_EXCLUDED_BRAND_API_URLS } from "./sf_constants";

//Function to get featur flag state
export const getFeatureFlagState = (feature_flag) => {

    if (feature_flag && feature_flag.state === 'on') {
        return FEATURE_FLAG_STATES.ON;
    }

    if (feature_flag && feature_flag.state === 'off') {
        return FEATURE_FLAG_STATES.OFF;
    }
    if (feature_flag && feature_flag.state === 'conditional') {
        return FEATURE_FLAG_STATES.PARTIAL;
    }


}

export const getAdminUserNameFromId = (adminUsers, adminUserId) => {
    const admin_user = adminUsers.find(admin_user => admin_user.id.toString() === adminUserId.toString());
    if (admin_user) {
        return `${admin_user.first_name} ${admin_user.last_name}`;
    }
    return '';
}

export const getAaccountNameFromId = (accounts, accountId) => {
    return accounts.find(account => account.id.toString() === accountId.toString())?.company_name;

}

export const getEnabledAccountsForFeatureFlag = (feature_flag_gates, accounts) => {

    let enabled_account_ids = []
    if (accounts.length === 0) {
        return enabled_account_ids
    }
    const enabled_actors = feature_flag_gates.find((feature_flag_gate) => feature_flag_gate.key === 'actors')
    const enabled_accounts = enabled_actors.value.filter((value) => value.startsWith('Account'))
    enabled_accounts.forEach((value) => {
        enabled_account_ids.push(value.split(';')[1])
    })
    return enabled_account_ids
}


export const getEnabledAdminUserIdsForFeatureFlag = (feature_flag_gates, adminUsers) => {

    let enabled_admin_user_ids = []
    if (adminUsers.length === 0) {
        return enabled_admin_user_ids
    }
    const enabled_actors = feature_flag_gates.find((feature_flag_gate) => feature_flag_gate.key === 'actors')
    const enabled_accounts = enabled_actors.value.filter((value) => value.startsWith('AdminUser'))
    enabled_accounts.forEach((value) => {
        enabled_admin_user_ids.push(value.split(';')[1])
    })
    return enabled_admin_user_ids
}

export const getFeaturFlagGatesStringForAccounts = (feature_flag_gates, account_owners) => {

    if (account_owners.length === 0) {
        return ''
    }

    let status_string_accounts = ''

    const enabled_actors = feature_flag_gates.find((feature_flag_gate) => feature_flag_gate.key === 'actors')
    enabled_actors.value.forEach((value) => {
        if (value.startsWith('Account')) {
            status_string_accounts += getAaccountNameFromId(account_owners, value.split(';')[1]) + ' , '
        }

    })

    return status_string_accounts
}

export const getFeaturFlagGatesStringForAdminUsers = (feature_flag_gates, employees) => {

    if (employees.length === 0) {
        return ''
    }

    let status_string_admin_users = ''

    const enabled_actors = feature_flag_gates.find((feature_flag_gate) => feature_flag_gate.key === 'actors')
    enabled_actors.value.forEach((value) => {

        if (value.startsWith('AdminUser')) {
            status_string_admin_users += getAdminUserNameFromId(employees, value.split(';')[1]) + ' , '
        }

    })

    return status_string_admin_users
}
export const getFeatureFlagStateText = (feature_flag) => {
    switch (getFeatureFlagState(feature_flag)) {
        case FEATURE_FLAG_STATES.ON:
            return 'On';
        case FEATURE_FLAG_STATES.OFF:
            return 'Off';
        case FEATURE_FLAG_STATES.PARTIAL:
            {

            }

    }
}

export const getAdminDashboardComponent = (isRevampEnabled) => {
    return isRevampEnabled
        ? () => import("../../src/pages/Admin/DashboardRevamp/index")
        : () => import("../../src/pages/Admin/Dashboard/index")
};

const normalizeBrandApiUrl = (api_url) => {
    return (api_url || '').trim().toLowerCase().replace(/\/+$/, '');
};

export const brandsReceivingFeatureFlags = (whitelisted_brands) => {
    const excluded_api_urls = FEATURE_FLAG_SYNC_EXCLUDED_BRAND_API_URLS.map(normalizeBrandApiUrl);

    return (whitelisted_brands || []).filter((brand) => {
        return !excluded_api_urls.includes(normalizeBrandApiUrl(brand?.api_url));
    });
};
